import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { AddeableComponent } from '../../../../shared/components/interfaces/addeable.component';
import { AuthService } from '../../../security/service/auth.service';
import { ProductUIMessages } from '../../model/product-ui.messages';
import { KeywordService } from '../../service/keyword.service';
import { UIActiveDialogService } from './../../../../shared/services/ui-dialog.service';
@Component({
  selector: 'keywords-add',
  templateUrl:
    './console/app-js/modules/product/components/keywords/keywords-add.component.html'
})
export class KeywordsAddComponent extends APIOperableComponent
  implements AddeableComponent {
  private productId: number;
  private existingKeywords: Array<string>;
  private keywordToEdit: any;
  private formGroup: FormGroup;
  private addingMultipleKeywords: boolean;
  public pageLoading = false;

  constructor(
    @Inject('productId') productId: number,
    @Inject('existingKeywords') existingKeywords: Array<string>,
    @Inject('currentKeyword') currentKeyword: string,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private keywordService: KeywordService,
    private activeDialogService: UIActiveDialogService
  ) {
    super(progressService, toastr, authService);
    this.productId = productId;
    this.existingKeywords = existingKeywords ? existingKeywords : [];
    this.keywordToEdit = currentKeyword ? currentKeyword : null;
    this.formGroup = new FormGroup({
      keyword: new FormControl('', Validators.required)
    });
  }

  /**
   * Save keyword upon clicking save button
   */
  onSave(): void {
    !this.keywordToEdit ? this.sendKeyword(true) : this.editKeyword();
  }

  /**
   * Dismiss UI modal upon cancelling add keywrord
   */
  onCancel(): void {
    this.addingMultipleKeywords
      ? this.activeDialogService.close(true)
      : this.activeDialogService.dismiss();
  }

  /**
   * Save a keyword without closing the modal
   */
  onSaveAndAddNew(): void {
    this.addingMultipleKeywords = true;
    this.sendKeyword(false);
  }

  /**
   * Send keyword model to product service and handle response
   * @param closeModal - boolean value determining if the modal closes after execution
   */
  sendKeyword(closeModal: boolean): void {
    this.pageLoading = true;
    this.keywordService
      .createKeyword(this.productId, this.formGroup.get('keyword').value)
      .subscribe(
        res => {
          if (res && res.results) {
            this.onAPISuccess(ProductUIMessages.ADD_KEYWORD_SUCCESS);
            this.existingKeywords.push(this.formGroup.get('keyword').value);
            if (closeModal) {
              this.activeDialogService.close(true);
            } else {
              this.formGroup.reset({ keyword: '' });
            }
          } else {
            this.pageLoading = false;
            this.onAPIError(ProductUIMessages.ADD_KEYWORD_ERROR);
          }
          this.pageLoading = false;
        },
        error => {
          this.pageLoading = false;
          this.onAPIError(ProductUIMessages.ADD_KEYWORD_ERROR);
        }
      );
  }

  /**
   * Send editted keyword to product service to be updated and handle response
   */
  editKeyword(): void {
    const newKeyword = this.formGroup.get('keyword').value;
    this.keywordService
      .updateKeyword(this.productId, newKeyword, this.keywordToEdit.id)
      .subscribe(
        res => {
          if (res && res.results) {
            this.onAPISuccess(ProductUIMessages.EDIT_KEYWORD_SUCCESS);
            this.existingKeywords.push(this.formGroup.get('keyword').value);
            const oldValueIndex = this.existingKeywords.indexOf(
              this.keywordToEdit.keyword
            );
            this.existingKeywords.splice(oldValueIndex, 1);
            this.activeDialogService.close(true);
          }
        },
        error => {
          this.onAPIError(ProductUIMessages.EDIT_KEYWORD_ERROR);
        }
      );
  }

  /**
   * Determines if the current keyword input by user is already in use.
   * @returns {boolean}
   */
  protected isKeywordInUse(): boolean {
    let match = '';
    match = this.existingKeywords.find(
      word =>
        word.trim().toLocaleLowerCase() ===
        this.formGroup
          .get('keyword')
          .value.trim()
          .toLocaleLowerCase()
    );
    return match && match.length > 0;
  }
}
